module.exports = __webpack_public_path__ + "img/title-left.f8c140ba.png";